<template>
  <div class="video">
    <!-- <video 
    width="100%" 
    controls 
    x5-playsinline='true'
    webkit-playsinline='true' 
    playsinline='true'
    preload="auto"
    > -->
    <video 
      width="100%" 
      controls 
      >
      <source src="http://www.cippe.com.cn/wx/video/1.mp4" type="video/mp4">
      <!-- <source src="movie.ogg" type="video/ogg"> -->
      您的浏览器不支持 video 标签。
    </video>
    <div class="showWinning" @click="$jumpWeb('http://www.cippe.com.cn/prize/index_en.html')">
      <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/app/jinjiang_en.png" alt=""/>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
  /* .video{
    padding: 0 8px;
  } */
  .video video{
    height: 190px;
  }

  .showWinning{
    width: 100%;
    border-radius: 5px;
    overflow: hidden;
    margin: 10px 0;
  }
  .showWinning img{
    width: 100%;
  }
</style>